import { Home } from '@lmc/ts-common'
import { useSelector } from 'react-redux'

const useDevicesAccess = (): boolean => {
  const deviceAccessControl: boolean | undefined = useSelector(
    (state: { global: { home: Home } }) =>
      state.global.home.features?.deviceAccessControl?.enabled
  )

  return Boolean(deviceAccessControl)
}

export default useDevicesAccess
